// extracted by mini-css-extract-plugin
export default {"menu-item":"MenuItem_menu-item__4QbMR","menu-item-color-negative":"MenuItem_menu-item-color-negative__pinsr"};